<navaar-container-scroll
    class="list-categories"
    [showHeader]="true"
    [title]="'بسته اشتراک'"
    [show]="true"
    [isPlayAnimation]="false"
    [showIcon]="true"
    [isFixedContainer]="true"
    [back-url]="['/profile']"
>
    <div class="subscription-main">
        <section class="subscription-current-plan-section">
            <ng-template
                [ngIf]="isLogin"
                [ngIfElse]="not_login"
            >
                <div class="container">
                    <div
                        class="current-plan-container"
                        *ngIf="userSubscriptionStatus"
                    >
                        <div class="user-subscription-plan-img">
                            <img
                                [src]="_environment.imageUrl + userSubscriptionStatus.activeSubscriptionImageUrl"
                                *ngIf="userSubscriptionStatus.hasActiveSubscription && userSubscriptionStatus.activeSubscriptionImageUrl"
                            >
                            <ng-template [ngIf]="!userSubscriptionStatus.hasActiveSubscription">
                                <ng-container *ngTemplateOutlet="logo"></ng-container>
                            </ng-template>
                        </div>
                        <div
                            class="title"
                            [ngClass]="userSubscriptionStatus.activeSubscriptionThemeColor"
                            *ngIf="userSubscriptionStatus.hasActiveSubscription"
                        >
                            بسته {{ userSubscriptionStatus['activeSubscriptionTitle'] }} برای شما فعال است
                        </div>
                        <div
                            class="title"
                            [ngClass]="userSubscriptionStatus.activeSubscriptionThemeColor"
                            *ngIf="!userSubscriptionStatus.hasActiveSubscription"
                        >
                            شما هیچ بسته فعالی ندارید!
                        </div>
                        <p
                            class="subtitle"
                            *ngIf="!userSubscriptionStatus.hasActiveSubscription"
                        >
                            با دریافت اشتراک نوار از مزایا و تخفیف‌های ویژه‌ی مشترکین بهره‌مند شوید
                        </p>
                        <div
                            class="reminders-container"
                            *ngIf="userSubscriptionStatus.hasActiveSubscription"
                        >
                            <div class="reminder-item">
                                <div
                                    class="icon-holder badge1"
                                    [attr.data-badge]="userSubscriptionStatus.totalPlanMemebershipQuota"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 18.112 16.001"
                                    >
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #fff;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                }
                                            </style>
                                        </defs>
                                        <g
                                            id="Group_3187"
                                            data-name="Group 3187"
                                            transform="translate(-108.5 -4686.388)"
                                        >
                                            <g
                                                id="Group_1006"
                                                data-name="Group 1006"
                                                transform="translate(-880 4487)"
                                            >
                                                <rect
                                                    id="Rectangle_312"
                                                    data-name="Rectangle 312"
                                                    class="cls-1"
                                                    width="3.075"
                                                    height="14.474"
                                                    transform="translate(989 200.316)"
                                                ></rect>
                                                <rect
                                                    id="Rectangle_313"
                                                    data-name="Rectangle 313"
                                                    class="cls-1"
                                                    width="3.075"
                                                    height="12.831"
                                                    transform="translate(992.075 201.959)"
                                                ></rect>
                                                <rect
                                                    id="Rectangle_314"
                                                    data-name="Rectangle 314"
                                                    class="cls-1"
                                                    width="3.075"
                                                    height="14.474"
                                                    transform="translate(995.203 200.316)"
                                                ></rect>
                                                <rect
                                                    id="Rectangle_315"
                                                    data-name="Rectangle 315"
                                                    class="cls-1"
                                                    width="3.075"
                                                    height="14.474"
                                                    transform="matrix(-0.966, 0.259, -0.259, -0.966, 1006, 213.981)"
                                                ></rect>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                <span *ngIf="!userSubscriptionStatus.hasSubscriptionQuota">سهمیه اشتراک شما استفاده شده است</span>
                                <span *ngIf="userSubscriptionStatus.hasSubscriptionQuota">
                                    {{userSubscriptionStatus.maxMembershipQuota - userSubscriptionStatus.currentMembershipUsage}} کتاب صوتی از سهمیه این اشتراک باقیمانده است
                                </span>
                            </div>
                            <!-- totalDaysToExpiration -->
                            <div class="reminder-item">
                                <div class="icon-holder">
                                    <svg
                                        id="Group_3190"
                                        data-name="Group 3190"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 16.8 19.525"
                                    >
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #fff;
                                                    stroke-miterlimit: 10;
                                                }
                                            </style>
                                        </defs>
                                        <circle
                                            id="Ellipse_325"
                                            data-name="Ellipse 325"
                                            class="cls-1"
                                            cx="7.9"
                                            cy="7.9"
                                            r="7.9"
                                            transform="translate(0.5 3.226)"
                                        ></circle>
                                        <circle
                                            id="Ellipse_326"
                                            data-name="Ellipse 326"
                                            class="cls-1"
                                            cx="1.086"
                                            cy="1.086"
                                            r="1.086"
                                            transform="translate(7.314 10.04)"
                                        ></circle>
                                        <line
                                            id="Line_230"
                                            data-name="Line 230"
                                            class="cls-1"
                                            x1="3.407"
                                            y1="3.301"
                                            transform="translate(4.205 7.08)"
                                        ></line>
                                        <line
                                            id="Line_231"
                                            data-name="Line 231"
                                            class="cls-1"
                                            y1="2.726"
                                            transform="translate(8.4 0.5)"
                                        ></line>
                                        <line
                                            id="Line_232"
                                            data-name="Line 232"
                                            class="cls-1"
                                            x2="4.387"
                                            transform="translate(6.143 0.5)"
                                        ></line>
                                        <line
                                            id="Line_233"
                                            data-name="Line 233"
                                            class="cls-1"
                                            x1="1.107"
                                            y2="1.129"
                                            transform="translate(14.384 4.844)"
                                        ></line>
                                    </svg>













                                </div>
                                {{userSubscriptionStatus.totalDaysToExpiration}} روز مانده تا پایان اشتراک
                            </div>
                            <!-- capsool -->
                            <div class="reminder-item">
                                <div class="icon-holder">
                                    <svg
                                        version="1.1"
                                        id="Layer_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="-39 38.3 19.7 19.7"
                                        style="enable-background:new -39 38.3 19.7 19.7;"
                                        :xml:space="preserve"
                                    >
                                        <style type="text/css">
                                            .st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}
                                        </style>
                                        <path
                                            id="Path_2769"
                                            class="st0"
                                            d="M-24.5,42.4h-9.2c-2.7,0-4.8,2.2-4.8,4.8l0,0c0,2.7,2.2,4.8,4.8,4.8h0.6l2.6,3
                c0.1,0.2,0.3,0.3,0.6,0.3c0.6,0.1,1.1-0.2,1.2-0.8c0-0.1,0-0.2,0-0.2V52h4.1c2.7,0,4.8-2.2,4.8-4.8l0,0c0-2.6-2-4.8-4.6-4.8
                C-24.5,42.4-24.5,42.4-24.5,42.4z"
                                        ></path>
                                    </svg>













                                </div>
                                <span *ngIf="userSubscriptionStatus.remainders['0'].remainderCount > 50">استفاده نامحدود از کپسول</span>
                                <span *ngIf="userSubscriptionStatus.remainders['0'].remainderCount <= 50">
                                    از {{userSubscriptionStatus.remainders["0"].maxQuota}} کپسول {{userSubscriptionStatus.remainders["0"].limitTypeDescription}} {{userSubscriptionStatus.remainders["0"].remainderCount}} عدد باقیمانده
                                </span>













                            </div>
                            <!-- serials -->
                            <div class="reminder-item">
                                <div class="icon-holder">













                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 17 17"
                                    >
                                        <defs>
                                            <style>
                                                .cls-1, .cls-2 {
                      fill: none;
                      stroke: #fff;
                      stroke-miterlimit: 10;
                    }

                    .cls-1 {
                      fill-rule: evenodd;
                    }
                                            </style>
                                        </defs>
                                        <g
                                            id="Group_3189"
                                            data-name="Group 3189"
                                            transform="translate(0.5 0.5)"
                                        >
                                            <path
                                                id="Path_2770"
                                                data-name="Path 2770"
                                                class="cls-1"
                                                d="M21.294,21.426h0A5.808,5.808,0,0,1,15.5,15.589V7.5H27.088v8.089A5.808,5.808,0,0,1,21.294,21.426Z"
                                                transform="translate(-11.088 -5.426)"
                                            ></path>
                                            <g
                                                id="Group_3188"
                                                data-name="Group 3188"
                                                transform="translate(7 6.43)"
                                            >
                                                <line
                                                    id="Line_227"
                                                    data-name="Line 227"
                                                    class="cls-2"
                                                    x2="6.412"
                                                    transform="translate(0 4.622)"
                                                ></line>
                                                <line
                                                    id="Line_228"
                                                    data-name="Line 228"
                                                    class="cls-2"
                                                    x2="1.794"
                                                ></line>
                                                <line
                                                    id="Line_229"
                                                    data-name="Line 229"
                                                    class="cls-2"
                                                    x2="1.794"
                                                    transform="translate(4.618)"
                                                ></line>
                                            </g>
                                            <path
                                                id="Path_2771"
                                                data-name="Path 2771"
                                                class="cls-1"
                                                d="M6.294,14.426h0A5.808,5.808,0,0,1,.5,8.589V.5H12.088V2.574"
                                                transform="translate(-0.5 -0.5)"
                                            ></path>
                                        </g>
                                    </svg>













                                </div>













                                <span *ngIf="userSubscriptionStatus.remainders['1'].remainderCount > 50">استفاده نامحدود از سریال صوتی</span>
                                <span *ngIf="userSubscriptionStatus.remainders['1'].remainderCount <= 50">
                                    از {{userSubscriptionStatus.remainders["1"].maxQuota}} سریال صوتی {{userSubscriptionStatus.remainders["1"].limitTypeDescription}} {{userSubscriptionStatus.remainders["1"].remainderCount}} عدد باقیمانده
                                </span>













                            </div>
                        </div>
                    </div>
                    <div
                        class="container plan-container"
                        *ngIf="userSubscriptionStatus != null &&
                        subscriptionPlans != null &&
                        !userSubscriptionStatus.hasActiveSubscription"
                    >
                        <ng-template
                            ngFor
                            [ngForOf]="subscriptionPlans"
                            let-item
                            let-i="index"
                        >
                            <ng-container *ngTemplateOutlet="plan_item; context: { $implicit: item, index: i }"></ng-container>
                        </ng-template>
                    </div>
                </div>
            </ng-template>
            <ng-template #not_login>
                <div class="container">
                    <div class="current-plan-container">
                        <div class="user-subscription-plan-img">
                            <ng-container *ngTemplateOutlet="logo"></ng-container>
                        </div>
                        <p class="title">شما هیچ بسته فعالی ندارید!</p>
                        <p class="subtitle">
                            با دریافت اشتراک نوار از مزایا و تخفیف‌های ویژه‌ی مشترکین بهره‌مند شوید
                        </p>
                    </div>
                    <div class="container plan-container">
                        <ng-template
                            ngFor
                            [ngForOf]="subscriptionPlans"
                            let-item
                            let-i="index"
                        >
                            <ng-container *ngTemplateOutlet="plan_item; context: { $implicit: item, index: i }"></ng-container>
                        </ng-template>
                    </div>
                </div>
            </ng-template>
        </section>
    </div>
</navaar-container-scroll>

<ng-template
    #plan_item
    let-item
    let-i="index"
>
    <div
        class="plan-button"
        [ngClass]="item.themeColor ? item.themeColor : 'blue'"
        (click)="openSlider(item, i, item.title)"
    >
        <img
            class="plan-icon-small"
            [src]="_environment.imageUrl + item['planIconPath'].substring(0, item['planIconPath'].length - 4) + '-white.svg'"
        >
        <span
            class="plan-title"
            [textContent]="item.title"
        ></span>
        <div class="detail-button-container">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 14.9 14.9"
            >
                <defs>
                    <style>.a{fill:#fff;fill-rule:evenodd;}</style>
                </defs>
                <g transform="translate(-1)">
                    <g transform="translate(1)">
                        <path
                            class="a"
                            d="M396,198.45a7.45,7.45,0,1,1,7.45,7.45A7.45,7.45,0,0,1,396,198.45Zm8.2-3.665.916.916-2.749,2.749,2.749,2.749-.916.916-3.665-3.665Z"
                            transform="translate(-396 -191)"
                        ></path>
                    </g>
                </g>
            </svg>
        </div>
        <div class="sub-detail-container">
            <span class="currency-sub-detail-text">تومان</span>
            <span class="sub-detail-text">
                ماهانه
                <b [textContent]="item.intervalCost / 10 | number"></b>
            </span>
        </div>
    </div>
</ng-template>
<ng-template #logo>
    <svg
    class="icon-svg-subscription"
    viewBox="-39 41 20 20"
>
    <style type="text/css">
        .subs-st0{fill:none;stroke:#A0A0A0;stroke-width:1pt;stroke-linecap:round;stroke-linejoin:round;}
    .subs-st1{fill:none;stroke:#A0A0A0;stroke-width:1pt;stroke-linecap:square;stroke-linejoin:round;}
    </style>
    <g id="Layer_1"></g>
    <g id="Layer_2">
        <g
            id="Group_1199"
            transform="translate(-29.625 -139.625)"
        >
            <path
                id="Path_532"
                class="subs-st0"
                d="M-9,200.2V181h19.3v19.2H-9z"
            ></path>
            <line
                id="Line_119"
                class="subs-st1"
                x1="4.9"
                y1="181"
                x2="4.9"
                y2="194.8"
            ></line>
            <line
                id="Line_121"
                class="subs-st1"
                x1="10.3"
                y1="194.8"
                x2="-3.6"
                y2="194.8"
            ></line>
            <line
                id="Line_119_1_"
                class="subs-st1"
                x1="-3.6"
                y1="200.2"
                x2="-3.6"
                y2="186.4"
            ></line>
            <line
                id="Line_121_1_"
                class="subs-st1"
                x1="-9"
                y1="186.4"
                x2="4.9"
                y2="186.4"
            ></line>
        </g>
    </g>
</svg>
</ng-template>
